import { AxiosError } from "axios";
import moment from "moment-timezone";
import {
  call,
  ForkEffect,
  put,
  putResolve,
  takeLeading,
} from "redux-saga/effects";
import {
  getActivitiesFeedbackFailure,
  getActivitiesFeedbackSussess,
  getResidentActivitiesFailure,
  getResidentActivitiesSussess,
  getResidentConfigurationFailure,
  getResidentConfigurationSussess,
  getResidentPresencesFailure,
  sendResidentActivityFailure,
  sendResidentActivitySussess,
} from "../../redux/residentActivityPlan/actions";
import {
  DAILY_PLAN,
  IGetActivitiesFeedbackOptionsRequest,
  IGetResidentsActivitiesRequest,
  IGetResidentsConfigurationRequest,
  ISendResidentActivityRequest,
} from "../../redux/residentActivityPlan/types";
import { AxiosCustom } from "../../service/Axios";
import { weirdData } from "../../redux/residentActivityPlan/";
import { notificationCongrat } from "../../redux/newNotification/actions";
import { NotificationState } from "../../redux/newNotification/types";
import { hidePreloader, showPreloader } from "../../redux/preloader/actions";

export function* getResidentsActivitiesWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_REQUEST,
    getResidentsActivitiesSaga
  );
}
function* getResidentsActivitiesSaga(action: IGetResidentsActivitiesRequest) {
  try {
    let startDate = action.payload.startDate;
    const startToday = moment().startOf("day").local();
    const now = moment();
    const diffTime = moment(now).diff(startToday);
    const duration = moment.duration(diffTime, "milliseconds");
    if (duration.asMilliseconds() < 60 * 60 * 1000) {
      //we've started less than an hour ago, we need possibly open activities
      startToday.subtract(1, "hour");
      startDate = weirdData(startToday);
    }

    const response = yield call(() =>
      AxiosCustom.getResidentsActivities(startDate, action.payload.endDate)
    );
    yield putResolve(
      getResidentActivitiesSussess(
        action.payload.startDate,
        action.payload.endDate,
        response.data
      )
    );
  } catch (error) {
    const e = error as AxiosError;
    yield put(getResidentActivitiesFailure(e.message));
    yield put(getResidentPresencesFailure(e.message));
  }
}

export function* getResidentsConfigurationsWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    DAILY_PLAN.GET_RESIDENTS_ACTIVITIES_CONFIGURATION_REQUEST,
    getResidentsConfigurationsSaga
  );
}
function* getResidentsConfigurationsSaga(
  action: IGetResidentsConfigurationRequest
) {
  try {
    const response = yield call(() => AxiosCustom.getResidentsConfigurations());
    yield putResolve(getResidentConfigurationSussess(response.data));
  } catch (error) {
    const e = error as AxiosError;
    yield put(getResidentConfigurationFailure(e.message));
  }
}

export function* getActivitiesFeedbackWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    DAILY_PLAN.GET_ACTIVITIES_FEEDBACK_OPTIONS_REQUEST,
    getActivitiesFeedbackSaga
  );
}
function* getActivitiesFeedbackSaga(
  action: IGetActivitiesFeedbackOptionsRequest
) {
  try {
    const result = yield call(() => AxiosCustom.getActivitiesFeedbackOptions());

    yield putResolve(getActivitiesFeedbackSussess(result.data));
  } catch (error) {
    const e = error as AxiosError;
    yield put(getActivitiesFeedbackFailure(e.message));
  }
}

export function* sendResidentActivityWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    DAILY_PLAN.SEND_RESIDENT_ACTIVITY_REQUEST,
    sendResidentActivitySaga
  );
}
function* sendResidentActivitySaga(action: ISendResidentActivityRequest) {
  try {
    yield put(showPreloader());
    yield call(() => AxiosCustom.sendResidentActivity(action.payload));
    yield put(hidePreloader());
    yield put(
      notificationCongrat({
        residentId: action.payload.residentId,
        type: action.payload.activityType,
        state: NotificationState.congrat,
      })
    );
    yield putResolve(sendResidentActivitySussess(action.payload));
  } catch (error) {
    const e = error as AxiosError;
    yield put(hidePreloader());
    yield put(sendResidentActivityFailure(e.message));
  }
}
